import { css } from '@emotion/react';

// Redux
import { useSelector } from 'react-redux';
import { standardSpacing, tripleSpacing } from 'styles/global_defaults/scaffolding';
import { NovoAIItemType } from 'redux/schemas/models/lecture-page';

// Components
import OrDivider from 'shared/components/sign-in/nv-or-divider';
import Header from './header';
import ContentSourceList from '../select-content-source/list';
import ContentRender from '../components';
import SuggestActivities from '../components/suggest-activities';
import AIComponentsList from '../select-component/ai-component-list';

const styles = css`
  & {
    gap: ${standardSpacing}px;
  }

  .contents-wrapper {
    min-width: 280px;
    max-width: 340px;
    display: flex;
    flex-direction: column;
    gap: ${tripleSpacing}px;
  }

  .or-divider {
    &::before,
    &::after {
      background: linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
    }
  }
`;

const NovoAiFlyout = () => {
  const selectedItemType = useSelector(state => state.app.lecturePage.novoAI.itemType);
  const selectedContentId = useSelector(state => state.app.lecturePage.novoAI.content?.id);

  return (
    <div
      className='w-100'
      css={styles}
    >
      <Header />
      <div className='d-flex flex-column align-items-center px-4'>
        {(!selectedItemType || selectedItemType === NovoAIItemType.SUGGEST_ACTIVITIES) && (
          <>
            <SuggestActivities />
            <OrDivider className='w-100 text-gray-2 my-5 font-weight-bolder' />
            <AIComponentsList />
          </>
        )}

        <div className='contents-wrapper mx-4'>
          {selectedItemType !== NovoAIItemType.SUGGEST_ACTIVITIES && selectedItemType && <ContentSourceList />}
          {selectedItemType && selectedContentId && <ContentRender itemType={selectedItemType} />}
        </div>
      </div>
    </div>
  );
};

export default NovoAiFlyout;
